exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "html, body {\n  height: 100%; }\n  html #root, body #root {\n    height: 100%; }\n\n.km-alert {\n  width: 200px;\n  height: 75px;\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center; }\n  .km-alert div {\n    color: white; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/stylesheets/App.sass
// module id = 1499
// module chunks = 0